import { connect } from 'react-redux';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import { withTranslation } from 'react-i18next';

import { APP_CAFETERIA } from 'app/common/constants/services';
import isToday from 'app/selectors/isToday';
import { getIsAppConnected } from 'app/selectors/applications';
import { dateFormat } from 'app/pages/routePaths';

import CardCafeteria from './CardCafeteria';


export default compose(
  withTranslation(),

  connect((state, props) => {
    const { t, id, date } = props;
    const isConnected = getIsAppConnected(state, { id, app: APP_CAFETERIA });
    if (!isConnected) {
      return ({ isConnected });
    }
    const today = isToday(state, props);
    const nSpent = state.cafeteria.costs.spent[id] || 0;
    const spent = (nSpent || today) ? t('children:spent', { nSpent }) : '';
    const nBalance = state.cafeteria.costs.balance[id] || 0;
    const balance = today ? t('children:balance', { nBalance }) : '';
    const link = `/apps/${id}/cafeteria/general/menu/${date.getString(dateFormat)}`; // TODO на основе prop

    return ({
      isConnected,
      spent,
      balance,
      link,
    });
  }),

  branch(
    ({ isConnected, spent, balance }) => (
      !isConnected || (!spent && !balance)
    ),
    renderNothing,
  ),

)(CardCafeteria);
